import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.image-marquee__splide' ).length ) {
        $( '.image-marquee__splide' ).each( function( index, element ) {
          const slider = new Splide( $( element )[0], {
            type: 'loop',
            drag: 'free',
            perPage: 1,
            gap: '2rem',
            autoWidth: true,
            arrows: false,
            pagination: false,
            autoScroll: {
              speed: .75,
              pauseOnFocus: false,
              pauseOnHover: false,
            },
          } );
          slider.mount( {AutoScroll} );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'image-marquee', COMPONENT );
} )( app );
